import { render } from "./ProduitService.vue?vue&type=template&id=1312e5f0"
import script from "./ProduitService.vue?vue&type=script&lang=js"
export * from "./ProduitService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__